var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 446,
    height: 147,
    viewBox: "0 0 446 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1597879908"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union",
    filter: "url(#filter0_d_304_91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.043 4C320.029 4.21979 320.019 4.44075 320.019 4.66406C320.019 10.0435 324.265 14.4035 329.505 14.4062C334.745 14.4035 338.991 10.0435 338.991 4.66406C338.991 4.44075 338.981 4.21979 338.967 4H430.652C436.914 4 441.99 9.21075 441.99 15.6387V52.6836C432.945 52.6854 425.612 60.214 425.612 69.5C425.612 78.7863 432.945 86.3146 441.99 86.3164V131.361C441.99 137.789 436.914 143 430.652 143H338.991C338.991 137.621 334.745 133.26 329.505 133.257C324.265 133.26 320.019 137.621 320.019 143H15.3379C9.07616 143 4.0001 137.789 4 131.361V86.3164C13.0451 86.3138 20.377 78.7857 20.377 69.5C20.377 60.2143 13.0451 52.6862 4 52.6836V15.6387C4.00011 9.21079 9.07616 4.00006 15.3379 4H320.043Z",
    fill: "url(#gradient-hover)",
    stroke: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M329.5 17C329.5 64.0382 329.5 84.6862 329.5 131.724",
    stroke: "#C1BFBF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "5 7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_304_91",
    x: 0,
    y: 0,
    width: 445.99,
    height: 147,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_304_91"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_304_91",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-hover",
    x1: 442.493,
    y1: 129.5,
    x2: 30.7075,
    y2: -35.7618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FFFB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketBg);
export default __webpack_public_path__ + "static/media/ticket-bg.03ae6a7665c68d920169c9dc988cd7bb.svg";
export { ForwardRef as ReactComponent };